
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import { reduxForm } from 'redux-form';
import { Search } from 'lucide-react';
import cx from 'classnames';

import { setPersonalizedValues } from '../../../../actions/personalized';
// Helper
import detectMobileBrowsers from '../../../../helpers/detectMobileBrowsers';
import history from '../../../../core/history';
// Locale
import messages from '../../../../locale/messages';

import s from './SearchForm.css';
import cs from '../../../commonStyle.css';
class SearchForm extends React.Component {
  static propTypes = {
    setPersonalizedValues: PropTypes.any.isRequired,
    getSpecificSettings: PropTypes.any.isRequired,
    personalized: PropTypes.shape({
      location: PropTypes.string,
      lat: PropTypes.number,
      lng: PropTypes.number,
      chosen: PropTypes.number,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      personCapacity: PropTypes.number,
      formatMessage: PropTypes.any,
    }),
    settingsData: PropTypes.shape({
      listSettings: PropTypes.array.isRequired
    }).isRequired
  };

  static defaultProps = {
    listingFields: []
  };


  static defaultProps = {
    personalized: {
      location: null,
      lat: null,
      lng: null,
      startDate: null,
      endDate: null,
      personCapacity: null,
      chosen: null,
      hideLabel: false
    },
    settingsData: {
      listSettings: []
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      mobileDevice: false,
      isLoad: false,
      personCapacity: [],
      searchQuery: '',
      inputFocused: false,
      currentPlaceholder: 'Yate en Miami para 10 personas...',
      placeholderIndex: 0
    };
    
    this.handleClick = this.handleClick.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputFocus = this.handleInputFocus.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    
    // Placeholder phrases
    this.placeholderPhrases = [
      'Yate en Miami para 10 personas...',
      'Lancha en Los Roques...',
      'Velero en Margarita...',
      'Catamarán para fiesta...',
      'Bote de pesca en Higuerote...'
    ];
  }

  componentDidMount() {
    this.setState({ isLoad: false });
    let isBrowser = typeof window !== 'undefined';
    if (isBrowser) {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }
    this.startPlaceholderRotation();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { listingFields } = nextProps;
    if (listingFields != undefined) {
      this.setState({
        roomType: listingFields.roomType,
        personCapacity: listingFields.personCapacity
      });
    }
  }

  UNSAFE_componentWillMount() {
    const { listingFields } = this.props;
    this.setState({ isLoad: true });
    if (detectMobileBrowsers.isMobile() === true) {
      this.setState({ mobileDevice: true });
    }
    if (listingFields != undefined) {
      this.setState({
        roomType: listingFields.roomType,
        personCapacity: listingFields.personCapacity
      });
    }

  }
  componentWillUnmount() {
    let isBrowser = typeof window !== 'undefined';
    if (isBrowser) {
      window.removeEventListener('resize', this.handleResize);
    }
    if (this.placeholderInterval) {
      clearInterval(this.placeholderInterval);
    }
  }
  
  startPlaceholderRotation() {
    this.placeholderInterval = setInterval(() => {
      if (!this.state.inputFocused && !this.state.searchQuery) {
        this.setState(prevState => {
          const nextIndex = (prevState.placeholderIndex + 1) % this.placeholderPhrases.length;
          return {
            placeholderIndex: nextIndex,
            currentPlaceholder: this.placeholderPhrases[nextIndex]
          };
        });
      }
    }, 3000);
  }
  
  handleInputChange(e) {
    this.setState({ searchQuery: e.target.value });
  }
  
  handleInputFocus() {
    this.setState({ inputFocused: true });
    if (this.placeholderInterval) {
      clearInterval(this.placeholderInterval);
    }
  }
  
  handleInputBlur() {
    this.setState({ inputFocused: false });
    this.startPlaceholderRotation();
  }
  
  handleSearch(e) {
    e && e.preventDefault();
    const { searchQuery } = this.state;
    if (!searchQuery.trim()) return;
    const params = new URLSearchParams();
    params.set('address', searchQuery.trim());
    params.set('chosen', '1');
    history.push(`/s?${params.toString()}`);
  }
  handleResize(e) {
    let isBrowser, smallDevice, verySmallDevice;
    isBrowser = typeof window !== 'undefined';
    smallDevice = isBrowser ? window.matchMedia('(max-width: 767px)').matches : true;
    verySmallDevice = isBrowser ? window.matchMedia('(max-width: 480px)').matches : false;

    this.setState({
      smallDevice,
      verySmallDevice
    });
  }

  handleClick() {

    const { personalized, setPersonalizedValues } = this.props;
    let updatedURI, uri = '/s?', existURI;

    if (personalized?.chosen != null) {
      uri = uri + '&address=' + personalized?.location + '&chosen=' + personalized?.chosen;
    } else {
      if (personalized?.location != null) {
        uri = uri + '&address=' + personalized?.location;
      }
    }

    if (personalized?.startDate != null && personalized?.endDate != null) {
      uri = uri + '&startDate=' + personalized?.startDate + '&endDate=' + personalized?.endDate;
    }

    if (personalized?.personCapacity != null && !isNaN(personalized?.personCapacity)) {
      uri = uri + '&guests=' + personalized?.personCapacity;
    }

    existURI = history?.location?.pathname + history?.location?.search
    updatedURI = encodeURI(uri);
    if (updatedURI === existURI) {
      history.replace(updatedURI);
    } else {
      history.push(updatedURI);
    }

  }

  render() {
    const { formatMessage } = this.props.intl;
    const { searchListing } = this.props;
    const { searchQuery, inputFocused, currentPlaceholder } = this.state;

    return (
      <form onSubmit={this.handleSearch} className={cx(s.searchGrid, 'homeSearchForm', 'searchGridRTL')}>
        <Search size={18} className={s.searchIcon} />
        <input
          type="text"
          className={s.searchInput}
          value={searchQuery}
          onChange={this.handleInputChange}
          onFocus={this.handleInputFocus}
          onBlur={this.handleInputBlur}
          placeholder={inputFocused ? formatMessage(messages.homeWhere) : currentPlaceholder}
        />
        <button 
          type="submit" 
          className={s.searchButton}
          disabled={searchListing || !searchQuery.trim()}
        >
          <Search size={18} />
          <span className={s.searchButtonText}>Buscar</span>
        </button>
      </form>
    );
  }
}
SearchForm = reduxForm({
  form: 'SearchForm', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(SearchForm);

const mapState = (state) => ({
  personalized: state?.personalized,
  settingsData: state?.viewListing?.settingsData,
  listingFields: state?.listingFields?.data,
  searchListing: state?.loader?.searchListing
});

const mapDispatch = {
  setPersonalizedValues
};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(SearchForm)));